export const compare = (options, content) => {
    const { text } = options.find(({ key }) => key === content);

    return text;
};
